import { create } from 'zustand';

interface CannotCreateNewCampaignModalState {
  isOpen: boolean;
  setIsOpen: (newVal: boolean) => void;
  type: 'shareableLink' | 'newCampaign';
  openAsShareableLink: () => void;
  openAsNewCampaign: () => void;
}

export const useCannotCreateNewCampaignModal = create<CannotCreateNewCampaignModalState>((set) => ({
  isOpen: false,
  setIsOpen: (newVal: boolean) => set({ isOpen: newVal }),
  // @ts-ignore
  type: 'multiQuestion',
  openAsShareableLink: () => set({isOpen: true, type: 'shareableLink'}),
  openAsNewCampaign: () => set({isOpen: true, type: 'newCampaign'})
}));